import { useCallback, useRef } from 'react';

import { config } from '@/configs/env';
import SendBrowserEvent from '@/services/SendBrowserEvent.service';
import { updateCallbackUrl } from '@/utils/path.util';

// Lazy import — avoids pulling react-toastify into the initial bundle.
// toast is only called inside event handlers, never at module init time.
const showToast = (msg: string) =>
  import('react-toastify').then(({ toast }) => toast.info(msg));

export class RedirectToLoginError extends Error {
  constructor(message = 'Redirecting to login') {
    super(message);
    this.name = 'RedirectToLoginError';
  }
}

export const useRedirectToLogin = (isNative?: boolean) => {
  const isRedirectingRef = useRef(false);

  const redirectToLogin = useCallback(
    (withToast?: boolean): void => {
      if (typeof window === 'undefined') {
        throw new RedirectToLoginError();
      }

      if (isRedirectingRef.current) {
        throw new RedirectToLoginError();
      }
      isRedirectingRef.current = true;

      const currentUrl = updateCallbackUrl();

      if (withToast) {
        void showToast('Please login before adding items to cart.');
      }

      if (isNative) {
        const url = `${config.ONBOARDING_URL}?callbackURI=${encodeURIComponent(
          currentUrl
        )}`;
        window.location.replace(url);
      } else {
        SendBrowserEvent.redirectToLoginPage();
      }

      // throw new RedirectToLoginError();
    },
    [isNative]
  );

  return redirectToLogin;
};
